export const MEDIA_QUIZZ = 'quizz'
export const MEDIA_QUESTIONBOX = 'questionBox'
export const MEDIA_SURVEY = 'survey'
export const MEDIA_NOTATION = 'notation'
export const MEDIA_ARTICLE = 'article'